import { useState, useEffect } from "react";
import styled from "styled-components";
import MiniCardCarousel from "./MiniCardCarousel";

export default function EvaluationCriteria() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex(prev => prev + 1);
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  return (
    <Section id="evaluation-criteria">
      <Container>

        <Deadline>Last date to submit nomination is 25-04-2026 (Saturday).</Deadline>

        <Heading>Evaluation Criteria For The Award</Heading>

        <Description>
          The application must align with at least one from each of the below
          criteria — <b>Social Impact, Scalability and Sustainability.</b><br/>
          Technology usage for engagement, impact and CSR compliance must be common.
        </Description>

        <MiniCardCarousel activeIndex={index} />

      </Container>
    </Section>
  );
}

/* STYLES */

const Section = styled.section`
scroll-margin-top: 100px;
  padding: 40px 20px 20px;
  background:#f5f7fa;

  @media (max-width: 768px) {
  scroll-margin-top: 100px;
    padding: 8px 2px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
  text-align: center;
`;

const Deadline = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #791e1b;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 6px;
  }
`;

const Heading = styled.h2`
  font-size: 38px;
  color: #791e1b;
  margin-bottom: 5px;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 2px;
  }
`;

const Description = styled.p`
  font-size:16px;
  line-height:1.8;
  color:#333;
  max-width: 1200px;
  margin-inline:auto;

  @media (max-width: 768px) {
    font-size: 12px;
    //margin-bottom: 4px;
  }
`;
